import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Title from '../Title/Title';
import ShowLessToggle from '../ShowLessToggle/ShowLessToggle';
import { Checkbox } from './Checkbox';
import './CheckboxList.less';

export default function CheckboxList({
  apiKeyName,
  list,
  selectedFilters,
  handleSetFilter,
  title,
  handleDropDownClick,
  showMoreShowLess,
  isRowExpanded,
  isOptionExpanded,
  isMobile,
  notPriceSectionBehaviour,
  sortSection,
  transitionEnd,
}) {
  const containerClass = cx(
    'common-filter__options-section',
    isRowExpanded ? `is-active` : ``,
    sortSection ? 'sort-section' : ''
  );

  const selectClasses = cx(
    'select--facet-options',
    !isOptionExpanded ? 'truncated' : 'expanded',
    !notPriceSectionBehaviour && 'price'
  );

  return (
    <div className={containerClass}>
      {isMobile && !notPriceSectionBehaviour && <h2 className="mobile-section-title">Filter</h2>}
      <Title
        handleDropDownClick={handleDropDownClick}
        apiKeyName={apiKeyName}
        name={title}
        isRowExpanded={isRowExpanded}
        filters={selectedFilters}
        list={list}
        isMobile={isMobile}
        sortSection={sortSection}
      />
      <div className={selectClasses} onTransitionEnd={() => !isMobile && transitionEnd()}>
        {list.map(({ value, result_count: count, label }, index) => (
          <Checkbox
            key={index}
            apiKeyName={apiKeyName}
            onChange={() => handleSetFilter(apiKeyName, value)}
            label={label}
            value={value}
            filters={selectedFilters}
            count={count}
          />
        ))}
      </div>
      {list.length > 6 && apiKeyName !== 'PRICE_RANGE' && isRowExpanded && isMobile && (
        <ShowLessToggle
          apiKeyName={apiKeyName}
          showMoreShowLess={showMoreShowLess}
          isOptionExpanded={isOptionExpanded}
        />
      )}
    </div>
  );
}

CheckboxList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      result_count: PropTypes.number,
      label: PropTypes.string,
    }).isRequired
  ).isRequired,
  selectedFilters: PropTypes.shape({}),
  handleSetFilter: PropTypes.func.isRequired,
  handleDropDownClick: PropTypes.func,
  showMoreShowLess: PropTypes.func,
  transitionEnd: PropTypes.func,
  apiKeyName: PropTypes.string,
  isMobile: PropTypes.bool,
  isRowExpanded: PropTypes.bool,
  isOptionExpanded: PropTypes.bool,
  notPriceSectionBehaviour: PropTypes.bool,
  sortSection: PropTypes.bool,
  title: PropTypes.string.isRequired,
};
